import React from 'react';

import { Icons } from '@icons/icons';

import { IPinActionProps } from './PinAction.types';

import DynamicIconWrapper from '../DynamicIconWrapper';

import './PinAction.scss';

const PinAction: React.FC<IPinActionProps> = ({
	isPinned,
	setIsPinned,
	pinTooltip,
	unpinTooltip,
	tooltipPlacement = 'auto',
}) => {
	const onUnpin = () => setIsPinned(false);
	const onPin = () => setIsPinned(true);

	return (
		isPinned
			? <div
				className='f5gPinAction'
				onClick={onUnpin}
			>
				<DynamicIconWrapper
					icon={Icons.unpin}
					tooltipLabel={unpinTooltip}
					tooltipPlacement={tooltipPlacement}
				/>
			</div>
			: <div
				className='f5gPinAction'
				onClick={onPin}
			>
				<DynamicIconWrapper
					icon={Icons.pin}
					tooltipLabel={pinTooltip}
					tooltipPlacement={tooltipPlacement}
				/>
			</div>
	);
};

export default PinAction;
